"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Default component for meta component.
 */
var React = require("react");
var DefaultComponentBase = (function (_super) {
    __extends(DefaultComponentBase, _super);
    function DefaultComponentBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultComponentBase.prototype.render = function () {
        var metaProps = {};
        var childProps = {};
        var metaKeys = this.getMetaPropNames();
        var meta = this.getMetaComponent();
        var defaultComponent = this.getChildComponent();
        for (var key in this.props) {
            if (!this.props.hasOwnProperty(key)) {
                continue;
            }
            if (metaKeys.indexOf(key) !== -1) {
                metaProps[key] = this.props[key];
            }
            else {
                childProps[key] = this.props[key];
            }
        }
        return React.createElement(meta, metaProps, React.createElement(defaultComponent, childProps));
    };
    return DefaultComponentBase;
}(React.Component));
exports.default = DefaultComponentBase;
//# sourceMappingURL=DefaultComponentBase.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/base/lib/DefaultComponentBase.js
// module id = ./node_modules/@react-mdc/base/lib/DefaultComponentBase.js
// module chunks = 1 2 3